
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: { DatePicker },
    props:{
        propertyName:{
            type: String,
            default: ''
        },
        categoryName:{
            type: String,
            default: ''
        },
        sellerPhone:{
            type: String,
            default: null
        },
    },
    data() {
        return {
            form: {
                name: null,
                phone: null,
                adults: 2,
                children: 0,
                date: null,
                fromDate: null,
                toDate: null,
                arrival: null,
                isDinner: true,
                property: this.propertyName,
                category: this.categoryName,
                sellerPh: this.sellerPhone
            },
            selectedBreakfast: true,
            formLoading: false,
            formSent: false,
            formError: null,
            arrivalOptions: [
                { value: null, text: 'Please select an option', disabled: true },
                { value: 'MOPA Airport', text: 'MOPA Airport' },
                { value: 'Dabolim Airport', text: 'Dabolim Airport' },
                { value: 'Thivim Railway Station', text: 'Thivim Railway Station' },
                { value: 'Karmali Railway Station', text: 'Karmali Railway Station' },
                { value: 'Margao Railway Station', text: 'Margao Railway Station' },
                { value: 'Vasco Railway Station', text: 'Vasco Railway Station' },
                { value: 'Panjim Bus Stand', text: 'Panjim Bus Stand' },
                { value: 'Mapusa Bus Stand', text: 'Mapusa Bus Stand' },
                { value: 'Margao Bus Stand', text: 'Margao Bus Stand' }
            ]
        }
    },
    methods: {

        disabledBeforeToday(date, currentSelectedDates) {
            const today = new Date();
            var currentDate = new Date();
            if (currentSelectedDates.length === 1) {
                var curDate = new Date(currentSelectedDates[0])
                curDate.setDate(curDate.getDate() - 1);
                return date <= curDate;
            } else {
                currentDate.setDate(currentDate.getDate() + 1);
                var format = 'hh:mm:ss'
                var time = moment(today, format)
                var beforeTime = moment('00:00:00', format);
                var afterTime = moment('17:00:00', format);
                if (time.isBetween(beforeTime, afterTime)) {
                    return date <= today;
                } else {
                    return date <= currentDate;
                }
            }

        },

        // To reset the form after successful submit
        resetForm() {
            var self = this; //you need this because *this* will refer to Object.keys below`
            //Iterate through each object field, key is name of the object field`
            Object.keys(this.form).forEach(function (key, index) {
                if (typeof self.form[key] != ("object" || "array")) {
                    self.form[key] = null;
                }
            });
            this.form.adults = 2;
            this.form.children = 0;
            this.form.isDinner = false;
            this.$refs.registrationForm.reset();
        },

        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },

        // Validate and Submit form data to a add category
        sendMessage() {
            // Clear all submit errors before API call
            this.formError = null;
            this.formSent = false;
            // Validate all fields for making the API call, throw error and not call API if validation errors are present
            this.$refs.registrationForm.validate().then(success => {
                if (!success || !this.form.date || this.form.date.length < 1 || !this.form.date[0] || !this.form.date[1]) {
                    // run your error code here
                    this.formError =
                        "One or more incorrect fields present, please fix.";
                } else {
                    // If Valid form
                    // Create formData instance to pass the data to the API
                    let formData = {
                        name: this.form.name,
                        phone: this.form.phone,
                        adults: this.form.adults,
                        children: this.form.children,
                        fromDate: this.form.date && this.form.date.length > 0 && this.form.date[0] && this.form.date[1] ? moment(this.form.date[0]).format("YYYY/MM/DD") : '',
                        toDate: this.form.date && this.form.date.length > 0 && this.form.date[0] && this.form.date[1] ? moment(this.form.date[1]).format("YYYY/MM/DD") : '',
                        arrival: this.form.arrival,
                        isDinner: this.form.isDinner,
                        property: this.form.property,
                        category: this.form.category,
                        ...(this.form.sellerPh? {seller:this.form.sellerPh}: {})
                    }
                    // Add header for the API
                    const headers = {};
                    this.formLoading = true;
                    // AXIOS api call to add categories api
                    this.$axios.post("/api/packageEnquiries", formData, {
                        headers: headers
                    })
                        .then(response => {
                            this.formSent = true;
                            this.$emit("modalTitle", "Inquiry Received");
                            this.resetForm();
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            });
        }
    }
}
